import { getApiDomain } from '@/utils/index'

const URL = `${getApiDomain()}reports/?`

export const downloadReport = (queryParams) => {
  window.open(`${URL}${queryParams}`, '_blank')
}



// WEBPACK FOOTER //
// ./src/services/reports.js